import { Box, Skeleton } from '@mui/material';

import FormGridLayout from 'components/common/formikForm/formGridLayout';

interface FormSkeletonProps {
    fields?: number;
}

const FormSkeleton = ({ fields = 6 }: FormSkeletonProps) => {
    return (
        <Box>
            <FormGridLayout>
                {Array.from({ length: fields }).map((_, index) => (
                    <Skeleton key={index} variant="rounded" height={40} sx={{ width: '100%' }} />
                ))}
            </FormGridLayout>

            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 2,
                    mt: 4,
                }}
            >
                <Skeleton variant="rounded" width={100} height={36} />
                <Skeleton variant="rounded" width={100} height={36} />
            </Box>
        </Box>
    );
};

export default FormSkeleton;
